<template>
  <div class="yhub_report">
    <img v-show="isPrint" src="@/assets/images/gpd_logo.png" style="margin: 5px 0 0 10px;height:30px;">

    <div class="headTitle">
      <span style="font-size: 20px;margin-right: 20px;">{{ basicinfo.deviceName }}</span>
      <span style="font-size: 18px;margin-right: 20px;">({{ basicinfo.deviceSn }})</span>
      <span class="fontStyle1">{{ $t("yhubReport.Machine") }}:{{ basicinfo.mechBrand }}
        {{ basicinfo.mechModel }}</span><!--设备-->
      <span class="fontStyle2" />
      <span class="fontStyle1">{{ $t("yhubReport.BatteryInformation") }}:{{ basicinfo.batteryBrand }}
        {{ basicinfo.batteryModels }} </span><!--电池型号-->
      <span v-if="basicinfo.batteryCapacity!=null" class="fontStyle1">&nbsp;&nbsp;{{ basicinfo.batteryCapacity }} Ah
      </span><!-- 容量-->
      <span class="fontStyle1">&nbsp;&nbsp;{{ basicinfo.batteryVoltage }} V </span><!--系统电压-->
      <span class="fontStyle2" />
      <span class="fontStyle1">{{ $t("yhubReport.FirmwareVersion") }}:V{{ basicinfo.fwVersion }}</span><!--固件-->
    </div>

    <div class="section_box">
      <!-- 日期选择器 -->
      <div class="flex_row">

        <el-date-picker v-model="selectDayWeekReport" type="daterange" :range-separator="$t('AllDevices.to')"
          :start-placeholder="$t('AllDevices.startDate')" :end-placeholder="$t('AllDevices.endDate')"
          @change="changeSearchWeekReport" style="margin-right: 20px;" />
        <el-radio-group v-model="activeTab" @change="handleClick">
          <el-radio-button label="prevDay">{{$t('yhubReport.yesterday')}}</el-radio-button>
          <el-radio-button label="prevWeek">{{$t('yhubReport.aWeek')}}</el-radio-button>
          <el-radio-button label="prevMonth">{{$t('yhubReport.aMonth')}}</el-radio-button>
        </el-radio-group>
        <!-- <el-tabs v-model="activeTab" type="card" @tab-click="handleClick">
          <el-tab-pane :label="$t('yhubReport.yesterday')" name="prevDay" />
          <el-tab-pane :label="$t('yhubReport.aWeek')" name="prevWeek" />
          <el-tab-pane :label="$t('yhubReport.aMonth')" name="prevMonth" />
        </el-tabs> -->
      </div>
      <div style="margin-bottom: 20px;">
        <p class="blockTitleP" style="display:inline-block; width: 400px;">
          {{ $t("yhubReport.chargeAndDischargeRecords") }}</p>
        <!--重新计算充放电按钮-->
        <el-button v-if="$store.state.isAdmin" type="primary" style="float: right; margin-top: 12px;"
          icon="el-icon-edit" size="mini" :title="$t('yhubReport.calculateChargeDischargeExceeded')"
          @click="toCalculateChargeDischarge" />
      </div>
      <!-- 柱状图 -->
      <div style="width:100%;position:relative;" class="columnLineWarp">
        <div id="chart2" class="chart" style="height:500px;width:100%;" />
        <i class="el-icon-question" :class="$store.state.language" @mouseout="mouseoutQuestion(0,'dischargePop')"
          @mouseover="mouseoverQuestion(0,'dischargePop')" />
        <p v-show="columnLineNoData"
          style="text-align: center;line-height: 30px;top: 200px;position: absolute;width: 100%;">
          {{ $t("yhubReport.Nodata") }}</p>
        <div class="dischargePop">
          <p>{{ $t('yhubReport.dischargeInfo') }}</p>
        </div>
        <!-- 由于打印时，需将图表转换成图片，用组件不太适合 -->
        <!-- <column-line-chart :column-line-data="columnLineData" :column-line-n="columnLineN" :height="columnLineHeight" /> -->
        <!-- <img v-show="isPrint" id="chart3" style="width:100%;height:500px;display:none;"> -->
      </div>
      <!-- Charged Records -->
      <p class="blockTitleP">
        {{ $t("yhubReport.Records") }}
        <el-button v-if="!$store.state.userInfo.guestFlag" type="primary" icon="el-icon-download"
          @click="downChargeDis" />
        <el-button type="primary" icon="el-icon-data-line" @click="readMore(null)" />
      </p>
      <el-table :data="chargedRecordsList" border style="width: auto" fit class="myTable chargedRecordTable"
        :span-method="objectSpanMethod">
        <el-table-column :label="$t('yhubReport.index')" prop="" align="center">
          <template slot-scope="scope">
            <div>
              <p>{{ scope.row.cycles }}</p>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="num" prop="num" align="center" />
          <el-table-column label="myCycleNum" prop="myCycleNum" align="center" />
          <el-table-column label="chargingNum" prop="chargingNum" align="center" /> -->
        <el-table-column :label="$t('yhubReport.StartingTime')" prop="startTime" align="center" />
        <el-table-column :label="$t('yhubReport.StartSOC')" prop="startSoc" align="center" />
        <el-table-column :label="$t('yhubReport.EndTime')" prop="endTime" align="center" />
        <el-table-column :label="$t('yhubReport.EndSOC')" prop="endSoc" align="center" />
        <el-table-column :label="$t('yhubReport.ah')" prop="energy" align="center" />
        <el-table-column label="KWH" prop="wh" align="center" />
        <el-table-column :label="$t('yhubReport.StartTemp')" prop="startTemp" align="center" />
        <el-table-column :label="$t('yhubReport.EndTemp')" prop="endTemp" align="center" />
        <el-table-column :label="$t('yhubReport.averageTemp')" prop="avgTemp" align="center" />
        <el-table-column :label="$t('yhubReport.MinVoltage')" prop="minVoltage" align="center" />
        <el-table-column :label="$t('yhubReport.MaxVoltage')" prop="maxVoltage" align="center" />
        <el-table-column :label="$t('yhubReport.ChargType')" prop="chargingTypeZh" align="center" />
        <el-table-column :label="$t('yhubReport.Duration')" prop="chargedTime" align="center" />
        <el-table-column :label="$t('AllDevices.Status')" prop="chargeDisStatu" align="center">
          <template slot-scope="scope">
            <div>
              <p v-if="scope.row.isChargeing">{{ $t('basicinfo.Charged') }}</p>
              <p v-if="!scope.row.isChargeing">{{ $t('basicinfo.DisCharged') }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('yhubReport.Charts')" prop="action" align="center" width="140px" fixed="right">
          <template slot-scope="scope">
            <div>
              <el-button type="primary" size="mini" class="el-icon-data-line" @click="readMore(scope.row)" />
              <el-button v-if="!scope.row.isChargeing&&$store.state.isAdmin" type="primary" size="mini" class=""
                @click="openCountSohPop(scope.row)">SOH</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- Warning -->
    <el-row :gutter="40" style="margin: 20px 0 0 0;">
      <el-col :xs="24" :sm="24" :lg="24" style="padding:0 20px 20px;background:white;position:relative;">
        <p class="blockTitleP" style="display:inline-block;">{{ $t('yhubReport.WarningMessage') }}</p>
        <!-- <div class="pane_content overhiden">
          <p v-for="(item,index) in warningList" :key="index" class="warningP" style="">{{ item.message }}</p>
          <p v-if="warningList.length==0" style="line-height: 60px;width: 100%;color: #909399;margin: 0;text-align: center;">{{ $t('yhubReport.NoWarnings') }}</p>
        </div> -->

        <el-table stripe :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}"
          border>
          <el-table-column prop="createTime" :label="$t('warningPage.CreatedAt')" align="center" min-width="10%" />
          <el-table-column prop="message" :label="$t('warningPage.Content')" align="center" min-width="35%" />
          <el-table-column prop="status" :label="$t('AllDevices.Status')" align="center" min-width="10%" />
          <el-table-column prop="updateTime" :label="$t('warningPage.SovledAt')" sortable align="center"
            min-width="10%" />

          <el-table-column prop="remark" :label="$t('warningPage.Remark')" align="center" min-width="15%" />

        </el-table>
        <!-- 列表模块————分页 -->
        <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;margin-top:20px;">
          <div class="pagination-container">
            <el-pagination v-if="pageshow" :page-size="listQuery.pageInfo.limit"
              :page-sizes="listQuery.pageInfo.pageList" :total="listQuery.pageInfo.total" background
              current-page.sync="listQuery.pageInfo.page" layout="total, sizes, prev, pager, next, jumper"
              @current-change="handleCurrentChange" @size-change="handleSizeChange" />
          </div>
        </div>
      </el-col>
    </el-row>

    <analogTem v-if="basicinfo.hourMeterStatus" :mcu-id="$route.query.mcuId" :start-time="weekReportStartTime"
      :end-time="weekReportEndTime" />

    <!-- Devices Summary -->
    <el-row :gutter="40" style="margin: 20px 0 0 0;">
      <el-col :xs="24" :sm="24" :lg="24" style="padding:0 20px 20px;background:white;position:relative;">
        <p class="blockTitleP" style="display:inline-block;">
          {{ $t('yhubReport.Dailystatistics') }}
          <el-button v-if="$store.state.userInfo.guestFlag!=true" align="right" style="text-align: center;float:right;"
            class="filter-item" type="primary" icon="el-icon-download" @click="downDeviceSummary" />
        </p>
        <div class="pane_content overhiden SummaryWarp">
          <div class="pane_content"
            style="border: 1px solid #F5F7FA;width:100%;margin-top:10px;margin-bottom:10px;position:relative;">
            <!-- <el-table border="" :data="odcDailyVoList" style='width:auto' fit class='myTable'>
            <el-table-column prop="monthDay" label="星期"> </el-table-column>
            <el-table-column prop="usedTime" label="使用时长"> </el-table-column>
            <el-table-column prop="workTime" label="工作时长"> </el-table-column>
            <el-table-column prop="usedRate" label="使用率"> </el-table-column>
            <el-table-column prop="usedAh" label="放电量"> </el-table-column>
            <el-table-column prop="charedAh" label="充电量"> </el-table-column>
            <el-table-column prop="minSoc" label="最低Soc"> </el-table-column>
            <el-table-column prop="minVoltage" label="最低电压"> </el-table-column>
            <el-table-column prop="maxTemprature" label="最高温度"> </el-table-column>
          </el-table> -->
            <div v-if="isShowWorkTimePop" class="WorkTimeWarp">
              <p>{{ $t('yhubReport.workTime') }}</p>
            </div>
            <div v-if="isShowUsedTimePop" class="usedTimeWarp">
              <p>{{ $t('yhubReport.usedTime') }}</p>
            </div>
            <table border="1"
              style="width:100%;text-align: center;line-height: 33px;font-size: 14px;color: #606266;border: none;border-collapse:collapse;">
              <thead style="line-height: 40px;">
                <th>{{ $t('yhubReport.Date') }}</th>
                <th>{{ $t('yhubReport.WorkingHours') }}<i class="el-icon-question" @mouseover="isShowWorkTimePop=true"
                    @mouseout="isShowWorkTimePop=false" /></th>
                <th>{{ $t('yhubReport.UseTime') }}<i class="el-icon-question" @mouseover="isShowUsedTimePop=true"
                    @mouseout="isShowUsedTimePop=false" /></th>
                <th>{{ $t('yhubReport.Discharge') }}</th>
                <th>{{ $t('basicinfo.DisCharged') }}(kWh)</th>
                <th>{{ $t('yhubReport.ChargingTime') }}</th>
                <th>{{ $t('yhubReport.Charge') }}</th>
                <th>{{ $t('basicinfo.Charged') }}(kWh)</th>
                <th>{{ $t('yhubReport.MinimumSOC') }}</th>
                <th>{{ $t('yhubReport.MinimumVoltage') }}</th>
                <th>{{ $t('yhubReport.MaximumTemperature') }}</th>
              </thead>
              <tbody style="color: #324057;" class="columnTable">
                <tr v-for="(item,index) in devicesSummaryList" :key="index">
                  <td>{{ item.monthDay }}</td>
                  <td>{{ item.workTimeZh }}</td>
                  <td>{{ item.usedTimeZh }} </td>
                  <td>{{ item.usedAhZh }}</td>
                  <td>{{ item.usingWhZh }}</td>
                  <td :title="item.chargeTime">{{ item.chargeTimeZh }}</td>
                  <td>{{ item.charedAhZh }} </td>
                  <td>{{ item.chargingWhZh }}</td>
                  <td>{{ item.minSocZh }}</td>
                  <td>{{ item.minVoltageZh }} </td>
                  <td>{{ item.maxTempratureZh }} </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="24" style="padding:0 20px 20px;background:white;position:relative;">
        <el-table v-show="!isPrint" border="" :data="devicesSummaryList" :row-class-name="rowIndex"
          style="width: 100%;margin-top: 10px;">
          <el-table-column prop="monthDay" min-width="10%" align="center" :label="$t('yhubReport.Date')" />
          <el-table-column min-width="40%" prop="1" :label="$t('yhubReport.Charts')" align="center">
            <template slot-scope="scope">
              <div>
                <div class="pieChartDiv">
                  <yhub-pie-chart class="myPieChartFirst" :series-data="scope.row.pieSeriesData1" :height="pieHeight"
                    :color-arr="colorArr1" />
                  <yhub-pie-chart class="myPieChartSecond" :series-data="scope.row.pieSeriesData2" :height="pieHeight"
                    :color-arr="colorArr2" style="display:none;" />
                </div>
                <div style="position: absolute;text-align: left;bottom: 20px;width:100%;">
                  <!-- 使用率、充放电比 -->
                  <button class="changePieBtn firstBtn active"
                    @click="changePieChart($event,1,scope.$index)">{{ $t("yhubReport.UsageRate") }}</button>
                  <button class="changePieBtn secondBtn"
                    @click="changePieChart($event,2,scope.$index)">{{ $t("yhubReport.Ratio") }}</button>
                  <div class="el-icon-question" style="font-size:20px;" @mouseover="mouseoverQuestion(scope.$index)"
                    @mouseout="mouseoutQuestion(scope.$index)" />
                  <!-- 选项卡处的问号弹窗 -->
                  <div class="questionPop">
                    <p v-if="$store.state.language=='en'||$store.state.language=='de'">{{ $t("yhubReport.Ratio") }} =
                      {{ $t("yhubReport.chargeDischargeRatio") }}</p>
                    <p>{{ $t('yhubReport.DischargeInfo') }}</p>
                    <p>{{ $t('yhubReport.ChargeInfo') }}</p>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="50%" prop="2" :label="$t('yhubReport.AHDistribution')" align="center">
            <template slot-scope="scope">
              <yhubReportBarChart :height="pieHeight" :data-detail="scope.row.odcEventDailyVoList1" />
              <!-- <yhub-bar-chart prop="odcEventDailyVoList" :height="pieHeight" :data-detail="scope.row.odcEventDailyVoList" /> -->
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <yhubReportTem v-if="basicinfo.hourMeterStatus" :mcu-id="$route.query.mcuId" :start-time="weekReportStartTime"
      :end-time="weekReportEndTime" />

    <lineChartRestCount v-if="$store.state.isAdmin" :line-date="lineDate" :height="lineHeight2"
      style="margin-top:20px;background: #fff;" />

    <!-- 弹窗 -->
    <!-- 日期选择器 -->
    <!-- <el-row v-show="isShowPop" :gutter="40" class="popWrap">
      <div class="popContent">
        <div style="text-align: right;font-size: 22px;"><i class="el-icon-close" style="cursor: pointer;" @click="closePop" /></div>
        <div style="height: 40px;margin-bottom: 10px;">
          <el-date-picker v-model="selectDay" type="daterange" :range-separator="$t('basicinfo.to')" :start-placeholder="$t('basicinfo.startDate')" :end-placeholder="$t('basicinfo.endDate')" @change="changeSearch" />
          <el-button type="primary" align="right" style="text-align: center;float:right;margin-right: 40px" @click="downLoadExcel()">Download Raw CSV</el-button>
          <el-button type="primary" align="right" style="text-align: center;float:right;margin-right: 40px" @click="downLoadReportExcel()">Download Report CSV</el-button>
        </div>
        <div>
          <line-chart :line-chart-data="lineChartData" :height="lineHeight" />
        </div>
      </div>
    </el-row> -->

    <!-- 弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowPop" width="90%">
      <el-form ref="bindDeviceModel" label-position="right">
        <el-form-item>
          <!-- 日期选择器 -->
          <!-- <el-date-picker v-model="selectDay" type="daterange" :range-separator="$t('AllDevices.to')" :start-placeholder="$t('AllDevices.startDate')" :end-placeholder="$t('AllDevices.endDate')" @change="changeSearch" /> -->
          <el-date-picker v-model="popStartDate" type="datetime" size="mini" value-format="timestamp"
            :placeholder="$t('AllDevices.startDate')" />
          <span>{{ $t('AllDevices.to') }}</span>
          <el-date-picker v-model="popEndDate" type="datetime" size="mini" value-format="timestamp"
            :placeholder="$t('AllDevices.endDate')" />
          <el-button class="filter-item" type="primary" size="mini" icon="el-icon-search" @click="changeSearch" />
          <el-button v-if="$store.state.userInfo.guestFlag!=true" size="mini" type="primary" align="right"
            style="text-align: center;float:right;margin-right: 40px" @click="downLoadExcel()">Download Raw
            CSV</el-button>
          <el-button v-if="$store.state.userInfo.guestFlag!=true" size="mini" type="primary" align="right"
            style="text-align: center;float:right;margin-right: 40px" @click="downLoadReportExcel()">Download Report
            CSV</el-button>

        </el-form-item>
      </el-form>
      <el-form ref="bindDeviceModel" v-loading="loading" label-position="right">
        <el-form-item style="position:relative;">
          <p v-if="nodata"
            style="text-align: center;line-height: 30px;top: 50%;position: absolute;width: 100%;transform: translate(0, -50%);z-index:99;">
            {{ $t("yhubReport.Nodata") }}</p>
          <line-chart :line-chart-data="lineChartData" :height="lineHeight" :is-show-half-v="isShowHalfV"
            @legendselect="legendselect" />
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 用逗号" , "作小数点分隔符 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowRegionPop" class="regionPop" width="60%"
      style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
      <p class="regionP">{{ $t('yhubReport.UseComma') }} </p>
      <el-radio v-model="regionType" :label="2" @change="change">{{ $t('allDeviceDetail.Yes') }}</el-radio>
      <el-radio v-model="regionType" :label="1" @change="change">{{ $t('allDeviceDetail.no') }}</el-radio>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowRegionPop = false">{{ $t('button.Cancel') }}</el-button>
        <el-button type="primary" @click="submitPop">{{ $t('button.Submit') }}</el-button>
      </div>
    </el-dialog>
    <!-- 下载中 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowLoadingPop" width="60%"
      style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
      <p>{{ $t('button.Downloading') }}</p>
    </el-dialog>
    <!-- 弹窗--手动计算soh -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowCountSOHPop" width="90%">
      <el-form ref="bindDeviceModel" label-position="right">
        <!-- <el-row :gutter="40" style="margin: 20px 0 0 0;">
          <el-col :xs="24" :sm="24" :lg="24" style="padding:0 20px 20px;background:white;position:relative;"> -->
        <p class="blockTitleP" style="display:inline-block;padding-left:0;">{{ $t('warningPage.SOH') }}</p>
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <!-- <el-date-picker v-model="sohSearchObj.sohStartAndEndtime" :disabled="true" type="daterange" :range-separator="$t('AllDevices.to')" :start-placeholder="$t('AllDevices.startDate')" :end-placeholder="$t('AllDevices.endDate')" /> -->
          <div>
            <el-date-picker v-model="sohSearchObj.sohStartTime" :disabled="true" type="datetime" size="mini"
              value-format="timestamp" :placeholder="$t('AllDevices.startDate')" />
            <span style="padding: 0 5px;word-break: normal;">{{ $t('AllDevices.to') }}</span>
            <el-date-picker v-model="sohSearchObj.sohEndTime" :disabled="true" type="datetime" size="mini"
              value-format="timestamp" :placeholder="$t('AllDevices.endDate')" />
          </div>

          <div style="max-width: calc(100% - 360px);display: flex;justify-content: flex-end;align-items: center;">
            <span style="margin-left:10px;">{{ $t('allDeviceDetail.ignoreCharg') }}:</span>
            <el-select v-model="sohSearchObj.ignoreCharge" :placeholder="$t('allDeviceDetail.ignoreCharg')"
              class="filter-item" filterable style="width: 15%; padding-left: 10px;padding-right: 10px">
              <el-option v-for="(item,index) in ignoreChargeOptions" :key="index" :label="item.label"
                :value="item.value" />
            </el-select>
            <span style="margin-left:10px;">{{ $t('allDeviceDetail.saveDatabase') }}:</span>
            <el-select v-model="sohSearchObj.updateData" :placeholder="$t('allDeviceDetail.saveDatabase')"
              class="filter-item" filterable style="width: 15%; padding-left: 10px;padding-right: 10px">
              <el-option v-for="(item,index) in updateDataOptions" :key="index" :label="item.label"
                :value="item.value" />
            </el-select>
            <el-button align="right" style="text-align: center;float:right;" class="filter-item" type="primary"
              @click="computedSoh">{{ $t('allDeviceDetail.CalculateSOH') }}</el-button>
          </div>
        </div>
        <el-table v-loading="loadingSoh" :data="sohData" border style="width: auto;margin-top:10px;" fit
          class="myTable">
          <el-table-column :label="$t('yhubReport.StartingTime')" prop="start_timeZh" align="center" />
          <el-table-column :label="$t('yhubReport.EndTime')" prop="end_timeZh" align="center" />
          <el-table-column :label="$t('allDeviceDetail.dischargeA')" prop="currentUsing" align="center" />
          <el-table-column :label="$t('allDeviceDetail.highCurrent')" prop="current_capacity" align="center" />
          <el-table-column :label="$t('allDeviceDetail.SocVolt')" prop="socVolt" align="center" />
          <el-table-column :label="$t('allDeviceDetail.TheorySoc')" prop="soc_ll" align="center" />
          <el-table-column :label="$t('allDeviceDetail.Smoothsoc')" prop="soc_ph" align="center" />
          <el-table-column :label="$t('allDeviceDetail.SocNotSmooth')" prop="soc_wph" align="center" />
          <el-table-column :label="$t('allDeviceDetail.SocMidway')" prop="soc_zt" align="center" />
          <el-table-column :label="$t('allDeviceDetail.SOHaverage')" prop="soh_avg" align="center" />
          <el-table-column :label="$t('allDeviceDetail.FinallyAH')" prop="theoretical_capacity" align="center" />
        </el-table>
        <!-- </el-col>
        </el-row> -->
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { findDeviceInfo, getHourReport, getOdc, listChargingDischarging, listRecordData, listSohRecord, countSoh, calculateChargeDischarge } from '@/api/yhub'
import { deviceStatistic, getBaseYhubInfoBySn } from '@/api/allDevice'
import echarts from 'echarts'
import { getDateAndHour, usedTime, howLongAgo, getDateAndWeek } from '@/utils/updateTime.js'
import yhubPieChart from '@/components/yhubPieChart'
// import yhubBarChart from '@/components/yhubBarChart'
import yhubReportBarChart from '@/components/yhubReportBarChart'
import lineChartRestCount from '@/components/lineChartRestCount'
// import columnLineChart from '@/components/columnLineChart'
import lineChart from '@/components/lineChart'
import yhubReportTem from './components/yhubReportTem'
import analogTem from './components/analogTem'
import { thousandFn } from '@/utils/thousandFn.js'
import i18n from '@/i18n'
import { parseTime } from '@/utils'
import { listWarningPushMsg2, updatePushMsgDelFlag, exportWarningPushMsgCsv } from '@/api/warning'
// MQTT--------------start
// import mqtt from 'mqtt'
// import yhubproto from '@/proto/yhubproto'
import protobuf from 'protobufjs'
// import { MQTT_SERVICE, MQTT_USERNAME, MQTT_PASSWORD } from '@/utils/sysconstant.js'
import { temChange, temChangeUnit, temUnit } from '@/utils/temChange.js'
// const YhubRequest = yhubproto.lookup('framework.YhubRequest')
// var myOoptions = {}
// client = mqtt.connect(MQTT_SERVICE, myOoptions)
// var client
// MQTT--------------end
import apiproto from '@/proto/apiproto'
const GNSSProto = apiproto.lookup('com.yhub.pb.APIResponse')
import { pagination } from '@/utils/init_table' // 分页
import { handleFloat } from '@/utils'

export default {
  components: {
    yhubPieChart,
    lineChartRestCount,
    lineChart,
    yhubReportBarChart,
    yhubReportTem,
    analogTem
    // columnLineChart
  },
  filters: {
    handleFloat
  },
  data () {
    this.apiproto
    this.protobuf
    return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      basicinfo: {},
      param: {},
      chargedRecordsList: [],
      warningList: [],
      devicesSummaryList: [],
      devicesSummaryList1: [],
      pieHeight: '200px',
      colorArr1: ['#a9d252', '#ff8c23', '#019ad6'],
      colorArr2: ['#e2c31d', '#33cccc'],
      // columnLineHeight: '500px',
      // columnLineData: {},
      // columnLineN: [],
      columnLineNoData: false,
      msg: null, // MQTT
      dataSize: null,
      chargedAh: null,
      socData: [],
      jlcgImgBase64: null,
      isPrint: false,
      isShowPop: false,
      lineChartData: {
        d3: [],
        d4: [],
        d5: [],
        d6: [],
        d7: [],
        d8: [],
        d9: [],
        d10: [],
        d11: [],
        a1: [],
        a2: [],
        a3: [],
        a32: [],
        a4: [],
        a5: [],
        a6: [],
        a7: []
      },
      isShowHalfV: 0,
      legendselectStr: [],
      lineHeight: '600px',
      weekReportStartTime: new Date().setHours(0, 0, 0, 0) - 7 * 24 * 60 * 60 * 1000, // 开始时间 2019-11-21 -> 时间戳
      weekReportEndTime: new Date().setHours(0, 0, 0, 0), // 结束时间 2019-11-27 -> 时间戳
      // selectDay: [], // 日期选择
      selectDayWeekReport: [], // 日期选择
      selectDayOption: '1', // 下拉框--最近7天--选中的值
      selectDayOptions: [ // 下拉框--最近7天--内容
        {
          value: '1',
          label: '最近7天'
        },
        {
          value: '2',
          label: '最近30天'
        }
      ],
      popStartDate: getDateAndHour(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
      popEndDate: getDateAndHour(new Date().getTime()),
      popMcuId: null,
      popSn: null,
      row: {},
      chargedRecordArr: [],
      tableData: [], // 警告表格
      lineHeight2: '300px',
      lineDate: [],
      nodata: false,
      loading: false,
      isShowLoadingPop: false,
      todayLast: new Date().setHours(0, 0, 0) + 24 * 60 * 60 * 1000 - 1000, // 当天23:59:59
      upadateLast: new Date(Number(this.$route.query.latest)).setHours(0, 0, 0) + 24 * 60 * 60 * 1000 - 1000, // 最后更新日的23:59:59
      activeTab: 'prevWeek',
      todayTimeE: new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000, // 今天23:59:59
      prevWeekS: new Date().setHours(0, 0, 0, 0) - 6 * 24 * 60 * 60 * 1000, // 一周开始时间
      prevMonthS: new Date(new Date().setHours(0, 0, 0, 0)).setMonth(new Date().getMonth() - 1), // 一个月开始时间
      isShowCountSOHPop: false,
      sohSearchObj: {
        sohStartTime: null,
        sohEndTime: null,
        ignoreCharge: false,
        updateData: false
      },
      ignoreChargeOptions: [
        { label: i18n.t('allDeviceDetail.Yes'), value: true },
        { label: i18n.t('allDeviceDetail.no'), value: false }
      ],
      updateDataOptions: [
        { label: i18n.t('allDeviceDetail.Yes'), value: true },
        { label: i18n.t('allDeviceDetail.no'), value: false }
      ],
      sohData: [],
      loadingSoh: false,
      isShowWorkTimePop: false,
      isShowUsedTimePop: false,
      isShowRegionPop: false,
      regionType: 2,
      showAll: false
    }
  },
  computed: {
    language () {
      return this.$store.state.language
    }
  },
  watch: {
    language (newValue, oldValue) {
      // if (newValue == 'zh' || newValue == 'ft') { this.value1 = true } else { this.value1 = false }
      this.queryList()
      this.queryWarnings()
      setTimeout(() => {
        this.initChart2()
      }, 500)
      this.ignoreChargeOptions[0].label = this.updateDataOptions[0].label = i18n.t('allDeviceDetail.Yes')
      this.ignoreChargeOptions[1].label = this.updateDataOptions[1].label = i18n.t('allDeviceDetail.no')
      var oldLineDate = [...this.lineDate]
      this.lineDate = []
      this.lineDate = oldLineDate
    },
    devicesSummaryList1: {
      handler (newValue, oldValue) {
        this.devicesSummaryList1 = newValue // 把新值赋值给我们的属性数据
        // this.devicesSummaryList = this.devicesSummaryList1 // 把新值赋值给我们的属性数据
        // this.initChart() // 刷新echarts图表
      },
      deep: true
    }
  },
  beforeRouteLeave (to, from, next) {
    to.meta.keepAlive = true
    next()
  },
  mounted () {
    this.queryList()
    this.queryWarnings()
    setTimeout(() => {
      this.initChart2()
    }, 500)
    this.initDeviceStatistic()
    this.$nextTick(() => {
      var isShowDischargePopS = document.querySelectorAll('.dischargePop')
      isShowDischargePopS.forEach(v => {
        v.style.display = 'none'
      })
    })
  },
  created () {
    if (this.$route.query.showAll == 'true') this.showAll = true
    this.weekReportEndTime = this.$route.query.latest ? this.upadateLast : this.todayLast
    console.log(this.todayLast)
    this.weekReportStartTime = this.$route.query.latest ? (this.upadateLast - 1000 * 60 * 60 * 24 * 7 + 1000) : (this.todayLast - 7 * 24 * 60 * 60 * 1000 + 1000)
    this.selectDayWeekReport = [this.weekReportStartTime, this.weekReportEndTime]
    this.changeActiveTab()
  },
  methods: {
    handleClick () { // 点击时间选项卡
      if (this.activeTab == 'prevDay') {
        this.selectDayWeekReport = [new Date().setHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000, this.todayTimeE - 24 * 60 * 60 * 1000]
      } else if (this.activeTab == 'prevWeek') {
        this.selectDayWeekReport = [this.prevWeekS, this.todayTimeE]
      } else if (this.activeTab == 'prevMonth') {
        this.selectDayWeekReport = [this.prevMonthS, this.todayTimeE]
      }
      this.weekReportStartTime = new Date(this.selectDayWeekReport[0]).getTime()
      this.weekReportEndTime = new Date(this.selectDayWeekReport[1]).getTime()
      // console.log(this.weekReportStartTime, '--', this.weekReportEndTime)
      this.queryList()
      setTimeout(() => {
        this.initChart2()
      }, 500)
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryWarnings()
      this.$nextTick(() => {
        this.pageshow = true
      })
      this.initDeviceStatistic()
    },
    mouseoverQuestion (index, key) {
      if (!key) document.querySelectorAll('.questionPop')[index].style.display = 'block'
      if (key && key == 'dischargePop') document.querySelectorAll('.dischargePop')[index].style.display = 'block'
    },
    mouseoutQuestion (index, key) {
      if (!key) document.querySelectorAll('.questionPop')[index].style.display = 'none'
      if (key && key == 'dischargePop') document.querySelectorAll('.dischargePop')[index].style.display = 'none'
    },
    queryWarnings () {
      var param = {

        endDate: this.weekReportEndTime, //
        // startDate: new Date(getDateAndHour(new Date().getTime() - 30 * 24 * 60 * 60 * 1000, 'noTime')).getTime() - 8 * 60 * 60 * 1000, // 开始时间 2019-11-21 -> 时间戳
        startDate: this.weekReportStartTime, // 开始时间 2019-11-21 -> 时间戳
        key: this.$route.query.mcuId,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize, // 分页--每一页的列表的行数 10 20 50,
        showAll: this.showAll
      }
      listWarningPushMsg2(param).then(res => { // 警告信息列表数据
        if (res.resultCode === 1001) {
          if (!res.resultModel) { this.tableData = []; this.listQuery.pageInfo.total = this.listQuery.pageInfo.pageNum = 0; return }
          this.tableData = res.resultModel.list || []
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          for (var i = this.tableData.length - 1; i >= 0; i--) {
            var v = this.tableData[i]
            v.createTime = getDateAndHour(v.createTime, 'noYear')
            // v.createTime = getDateAndHour(v.createTime, 'noYear')
            if (v.delFlag == 1) { v.updateTime = getDateAndHour(v.updateTime, 'noYear'); v.status = i18n.t('warningPage.Solevd') } else { v.updateTime = '--'; v.status = i18n.t('warningPage.Unsolved') }
            switch (v.msgType) {
              case 1: {
                if (v.triggerValue) v.triggerValue = v.triggerValue > 100 ? Math.round(v.triggerValue / 100) : Math.round(v.triggerValue)
                v.message = i18n.t('warningInfo.batterySocLow1') + v.triggerValue + i18n.t(`warningInfo.batterySocLow2`); break
              }
              case 2: v.message = i18n.t('warningInfo.batteryWaterLow'); break
              case 4: {
                if (v.triggerValue) v.triggerValue = v.triggerValue > 100 ? Math.round(v.triggerValue / 100) : Math.round(v.triggerValue)
                v.message = i18n.t('warningInfo.batteryTemHeight1') + temChangeUnit(v.triggerValue) + i18n.t('warningInfo.batteryTemHeight2'); break
              }
              case 5: { v.message = i18n.t('warningInfo.batteryCapacity1') + v.triggerValue + i18n.t('warningInfo.batteryCapacity2'); break }
              case 6: { v.message = i18n.t('warningInfo.batteryNoPosition'); break }
              case 7: { v.message = i18n.t('warningInfo.batteryVoltageLow1') + v.triggerValue + i18n.t('warningInfo.batteryVoltageLow2'); break }
              case 8: { v.message = i18n.t('warningInfo.batteryTemLow1') + temChangeUnit(v.triggerValue) + i18n.t('warningInfo.batteryTemLow2'); break }
              case 9: { v.message = i18n.t('warningInfo.batteryTemAbnormal'); break }
              case 10: { v.message = i18n.t('warningInfo.batteryVoltageHeight1') + v.triggerValue + i18n.t('warningInfo.batteryVoltageHeight2'); break }
              case 15: { v.message = i18n.t('warningInfo.HalfVWarn'); break }
              case 16: { v.message = i18n.t('warningInfo.offlineWarn').replace('$1', v.triggerValue); break }
              case 17: { v.message = i18n.t('warningInfo.linChargeOverWarn'); break }
              case 18: {
                if (v.triggerValue) { v.triggerValueZh = getDateAndHour(v.triggerValue, 'noTime') }
                v.message = i18n.t('warningInfo.overTiemTo').replace('$1', v.triggerValueZh)
                break
              }
              case 19: { v.message = i18n.t('warningInfo.overTiem'); break }
              case 20: { v.message = i18n.t('warningSet.chargeDisAbnormalWarn'); break }
              case 21: { v.message = i18n.t('warningInfo.unitVLowWarn'); break }
              default: this.tableData.splice(i, 1)
            }
          }
        }
      })
    },
    queryList () {
      var param1 = {
        mcuId: this.$route.query.mcuId,
        myToken: this.$store.state.token
      }
      findDeviceInfo(param1).then(res => { // 基本信息
        // console.log(res.resultModel)
        if (res.resultCode == 1001 && res.resultModel) {
          this.basicinfo = res.resultModel || {}
          this.getFullChargeStatu()// 判断充放电记录表格中的满充和临时充电
          this.isShowHalfV = res.resultModel.halfV
          if (this.basicinfo.batteryVoltage) { this.basicinfo.batteryVoltage = this.basicinfo.batteryVoltage > 100 ? (this.basicinfo.batteryVoltage / 100) : this.basicinfo.batteryVoltage } else { this.basicinfo.batteryVoltage = '--' }
          if (this.basicinfo.batteryCapacity) { this.basicinfo.batteryCapacity = this.basicinfo.batteryCapacity > 100 ? Math.round(this.basicinfo.batteryCapacity / 100) : this.basicinfo.batteryCapacity } else { this.basicinfo.batteryCapacity = '--' }
        } else if (res.resultCode == 1001 && !res.resultModel && this.$store.state.companyId == 4) {
          getBaseYhubInfoBySn({ sn: this.$route.query.sn }).then(res => {
            this.basicinfo = res.resultModel
            this.basicinfo.deviceSn = res.resultModel.yhubSn
            this.basicinfo.batteryVoltage = (res.resultModel.productConfig && res.resultModel.productConfig.yhubConfigAdmin) ? res.resultModel.productConfig.yhubConfigAdmin.batterySystemVolt : '--'
            this.getFullChargeStatu()// 判断充放电记录表格中的满充和临时充电
          })
        }
      })
      this.param = {
        endDate: this.weekReportEndTime,
        mcuId: this.$route.query.mcuId,
        // mcuId: '05d9ff333332534e43202848',
        startDate: this.weekReportStartTime,
        showAll: this.showAll
      }
      getOdc(this.param).then(res => { // Devices Summary
        if (res.resultCode === 1001) {
          var myRes = JSON.parse(JSON.stringify(res.resultModel))
          myRes.forEach((v, i) => {
            v.monthDay = getDateAndWeek(Number(v.monthDay), this.$store.state.language)
            // if (v.monthDay && this.$store.state.language == 'zh')v.monthDay = '星期' + '日一二三四五六'.charAt(new Date(Number(v.monthDay)).getDay())
            // if (v.monthDay && this.$store.state.language == 'en')v.monthDay = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][new Date(Number(v.monthDay)).getDay()]
            // if (v.monthDay && this.$store.state.language == 'jp')v.monthDay = ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜'][new Date(Number(v.monthDay)).getDay()]
            v.pieSeriesData1 = []
            v.pieSeriesData1.push(
              { value: parseInt(v.chargeTime / 1000) || 0, name: i18n.t('yhubReport.ChargingTime'), key: 'charge', divClass: 'myPieChartFirst' },
              { value: parseInt((86400 - v.usedTime / 1000 - v.chargeTime / 1000)) || 0, name: i18n.t('basicinfo.Idled'), key: 'idel', divClass: 'myPieChartFirst' },
              { value: parseInt(v.usedTime / 1000) || 0, name: i18n.t('yhubReport.UseTime'), key: 'discharge', divClass: 'myPieChartFirst' }
            )
            v.pieSeriesData2 = []
            v.pieSeriesData2.push(
              { value: Math.round(v.charedAh / 100), name: i18n.t('QR.ChargedAH'), key: 'chargeAh', minSoc: v.minSoc, usedRate: v.usedRate, minVoltage: v.minVoltage, maxTemprature: v.maxTemprature, divClass: 'myPieChartSecond' },
              { value: Math.round(v.usedAh / 100), name: i18n.t('QR.dishargedAH'), key: 'dischargeAh', minSoc: v.minSoc, usedRate: v.usedRate, minVoltage: v.minVoltage, maxTemprature: v.maxTemprature, divClass: 'myPieChartSecond' }
            )
            // v.pieSeriesData2.formatter = '{b}: {c} Ah' +
            //               '<br/>Lowest SOC: ' + Math.round(v.minSoc / 100) + ' %' +
            //               '<br/>Used Rate: ' + v.usedRate + ' %' +
            //               '<br/>Lowest voltage: ' + v.minVoltage / 100 + ' V' +
            //               '<br/>Highest temperature: ' + Math.round(v.maxTemprature / 100) + ' ℃'
          })
          this.devicesSummaryList1 = myRes
          getHourReport(this.param).then(response => {
            console.log('devicesSummaryList1---', this.devicesSummaryList1)
            if (response.resultCode == 1001) {
              // console.log('getHourReport1------', this.devicesSummaryList1)
              // 当两个数组长度不一致时，取短
              if (this.devicesSummaryList1.length > response.resultModel.length) {
                this.devicesSummaryList1 = this.devicesSummaryList1.splice(0, response.resultModel.length)
              } else if (this.devicesSummaryList1.length < response.resultModel.length) {
                response.resultModel = response.resultModel.splice(0, this.devicesSummaryList1.length)
              }
              // console.log('getHourReport1------', this.devicesSummaryList1)
              // console.log('response.resultModel------', response.resultModel)
              this.devicesSummaryList1.forEach((m, mi) => {
                // console.log('response.resultModel[mi]--', response.resultModel[mi])
                if (m.chargingWh < 0 || !m.chargingWh) m.chargingWh = 0
                if (m.usingWh < 0 || !m.usingWh) m.chargingWh = 0
                m.workTimeZh = parseInt((m.workTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + ' h ' + parseInt((m.workTime % (1000 * 60 * 60)) / (60 * 1000)) + ' min'
                m.usedTimeZh = parseInt((m.usedTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + ' h ' + parseInt((m.usedTime % (1000 * 60 * 60)) / (60 * 1000)) + ' min'
                m.usedAhZh = handleFloat(m.usedAh / 100) + ' Ah'
                m.usingWhZh = handleFloat(m.usingWh / 100000) + ' kWh'
                m.chargeTimeZh = parseInt((m.chargeTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + ' h ' + parseInt((m.chargeTime % (1000 * 60 * 60)) / (60 * 1000)) + ' min'
                m.charedAhZh = handleFloat(m.charedAh / 100) + ' Ah'
                m.chargingWhZh = handleFloat(m.chargingWh / 100000) + ' kWh'
                m.minSocZh = Math.floor(m.minSoc / 100) + ' %'
                m.minVoltageZh = m.minVoltage / 100 + ' V'
                m.maxTempratureZh = temChangeUnit(Math.floor(m.maxTemprature / 100))

                response.resultModel.forEach((v, vi) => {
                  this.devicesSummaryList1[mi].odcEventDailyVoList1 = JSON.parse(response.resultModel[mi].jsonStr)
                })
              })
              this.devicesSummaryList = this.devicesSummaryList1
              this.$nextTick(() => {
                var arr = document.querySelectorAll('.questionPop')
                arr.forEach(v => {
                  v.style.display = 'none'
                })
              })
            }
          })
        }
      })
    },
    initDeviceStatistic () {
      var param = {
        mcuId: this.$route.query.mcuId,
        startDate: this.weekReportStartTime,
        endDate: this.weekReportEndTime
        // mcuId: '05d7ff373637574e43154358', // 假数据
        // startDate: 0,
        // endDate: 1592797083000
      }
      deviceStatistic(param).then(res => {
        if (res.resultCode == 1001) {
          this.lineDate = []
          res.resultModel.forEach(v => {
            this.lineDate.push({ rebootCount: v.rebootCount, summaryTime: v.summaryTime, value: v.rebootCount })
          })
        }
      })
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      var myRowspan = 0
      if (columnIndex === 0) {
        // console.log('this.chargedRecordsList------', row, '+', row.num)
        if (rowIndex > 0 && this.chargedRecordsList[rowIndex - 1].cycles == this.chargedRecordsList[rowIndex].cycles) {
          myRowspan = 0
        } else {
          myRowspan = row.num
        }
        return {
          rowspan: myRowspan,
          colspan: 1
        }
      } else if (columnIndex === 12) {
        return {
          rowspan: row.myCycleNum,
          colspan: 1
        }
      }
    },
    changeSearchWeekReport () { // 日期选择器
      // console.log(this.selectDayWeekReport)
      if (this.selectDayWeekReport) { // 选择了时间
        this.weekReportStartTime = new Date(this.selectDayWeekReport[0]).getTime()
        this.weekReportEndTime = new Date(this.selectDayWeekReport[1]).getTime() + 24 * 60 * 60 * 1000 - 1000
      } else {
        this.weekReportEndTime = this.$route.query.latest ? this.upadateLast : this.todayLast
        this.weekReportStartTime = this.$route.query.latest ? (this.upadateLast - 1000 * 60 * 60 * 24 * 7 + 1000) : (this.todayLast - 7 * 24 * 60 * 60 * 1000 + 1000)
      }
      this.changeActiveTab()
      this.queryList()
      setTimeout(() => {
        this.initChart2()
      }, 500)
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryWarnings()
      this.$nextTick(() => {
        this.pageshow = true
      })
      this.initDeviceStatistic()
      // console.log(this.weekReportEndTime)
    },
    changeActiveTab () { // 根据条件改变选项卡
      if (this.weekReportEndTime == this.todayTimeE) {
        if (this.weekReportStartTime == this.prevWeekS) {
          this.activeTab = 'prevWeek'
        } else if (this.weekReportStartTime == this.prevMonthS) {
          this.activeTab = 'prevMonth'
        } else {
          this.activeTab = ''
        }
      } else if (this.weekReportEndTime == (this.todayTimeE - 24 * 60 * 60 * 1000)) {
        if (this.weekReportStartTime == (new Date().setHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000)) {
          this.activeTab = 'prevDay'
        } else {
          this.activeTab = ''
        }
      } else {
        this.activeTab = ''
      }
    },
    // 饼状图切换
    changePieChart (event, val, index) {
      // 当在监控点击切换的时候，加个延迟主动触发窗口变化，这样窗口改变性能分析页就不会发生图表大小有问题的情况了 【这里的代码是关键！！！】
      setTimeout(() => {
        const triggerResize = new Event('resize')
        window.dispatchEvent(triggerResize)
        console.log('triggerResize--', triggerResize)
      }, 0)

      var eventParent = event.target.nodeName == 'SPAN' ? event.target.parentElement.parentElement : event.target.parentElement
      var eventDiv = document.getElementsByClassName('pieChartDiv')[index]
      if (val == 1) {
        eventDiv.firstChild.style.display = 'block'
        eventDiv.lastChild.style.display = 'none'
        eventParent.firstChild.classList.add('active')
        // eventParent.lastChild.classList.remove('active')
        eventParent.querySelector('.changePieBtn:nth-child(2)').classList.remove('active')
      } else if (val == 2) {
        eventDiv.firstChild.style.display = 'none'
        eventDiv.lastChild.style.display = 'block'
        eventParent.firstChild.classList.remove('active')
        // eventParent.lastChild.classList.add('active')
        eventParent.querySelector('.changePieBtn:nth-child(2)').classList.add('active')
      }
    },
    // 折线图----start
    initChart2 () { // 充放电记录
      var n = []
      var chargeData = []
      var disChargeData = []
      var socData = []
      var dom2 = document.getElementById('chart2')
      var myChart2 = echarts.init(dom2)
      myChart2.showLoading()
      this.dataSize = 0
      this.chargedAh = 0

      this.param = {
        endDate: this.weekReportEndTime,
        mcuId: this.$route.query.mcuId,
        // mcuId: '05d9ff333332534e43202848',
        startDate: this.weekReportStartTime,
        showAll: this.showAll
      }

      listChargingDischarging(this.param).then(response => {
        this.chargedRecordsList = JSON.parse(JSON.stringify(response.resultModel))
        this.chargedRecordArr = JSON.parse(JSON.stringify(response.resultModel))
        for (var i = this.chargedRecordsList.length - 1; i >= 0; i--) {
          var v = this.chargedRecordsList[i]
          if (!v.startWh || v.startWh < 0) v.startWh = 0
          if (!v.endWh || v.endWh < 0) v.endWh = 0
          v.wh = v.endWh - v.startWh > 0 ? handleFloat((v.endWh - v.startWh) / 1000) : 0
          v.startSoc = Math.floor(v.startSoc) + '%'
          v.endSoc = Math.floor(v.endSoc) + '%'
          v.startTemp = (v.startTemp || v.startTemp == 0) ? temChangeUnit(Math.floor(v.startTemp / 100)) : '--'
          v.endTemp = (v.endTemp || v.endTemp == 0) ? temChangeUnit(Math.floor(v.endTemp / 100)) : '--'
          v.avgTemp = (v.avgTemp || v.avgTemp == 0) ? temChangeUnit(Math.floor(v.avgTemp / 100)) : '--'
          v.minVoltage = (v.minVoltage || v.minVoltage == 0) ? (v.minVoltage / 100).toFixed(2) + 'V' : '--'
          v.maxVoltage = (v.maxVoltage || v.maxVoltage == 0) ? (v.maxVoltage / 100).toFixed(2) + 'V' : '--'
          // switch (v.chargingType) {
          //   case 1:v.chargingTypeZh = i18n.t('yhubReport.FullCharge'); break// '满充'
          //   case 2:v.chargingTypeZh = i18n.t('yhubReport.Intermediate'); break// '临时充电'
          //   default:v.chargingTypeZh = '--'; break
          // }
          if (v.startTime && v.endTime) {
            var myTime = (new Date(v.endTime) - new Date(v.startTime))
            if (v.startTime) { v.startTimeRes = v.startTime; v.startTime = getDateAndHour(v.startTime, 'noYear') }
            if (v.endTime) { v.endTimeRes = v.endTime; v.endTime = getDateAndHour(v.endTime, 'noYear') }
            if ((v.startAh && v.endAh) || v.startAh == 0 || v.endAh == 0) v.energy = handleFloat(v.endAh - v.startAh)
            // v.chargedTime = parseInt((myTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + ' h ' + parseInt((myTime % (1000 * 60 * 60)) / (1000 * 60)) + ' min '
            v.chargedTime = usedTime(myTime, 'noSecond')
          }
          // if(v.chargedTime)v.chargedTime=updateTime()
        }
        // 动态合并单元格
        var cyclesIds = []
        this.chargedRecordsList.forEach((v, i) => {
          if (v.cycles) cyclesIds.push(v.cycles)
          v.num = 1
          v.chargingNum = 1
        })
        this.chargedRecordsList.forEach((v, i) => {
          if (!v.cycles) { // 如果最后的数据未形成一个循环，则后台不返回cycles，前端自定义为前一个cycles+1
            if (cyclesIds.length > 0) {
              v.cycles = cyclesIds[cyclesIds.length - 1] + 1
            } else {
              v.cycles = '--'
            }
          }
        })
        this.chargedRecordsList.forEach((v, i) => {
          if (i < this.chargedRecordsList.length - 1 && v.cycles == this.chargedRecordsList[i + 1].cycles) {
            v.num++
            this.chargedRecordsList[i + 1].num = v.num
            if (v.isChargeing && this.chargedRecordsList[i + 1].isChargeing) {
              v.chargingNum++
              this.chargedRecordsList[i + 1].chargingNum = v.chargingNum
            }
          }
          if (v.isChargeing) v.chargeDisStatu = i18n.t('basicinfo.Charged')
          if (!v.isChargeing) v.chargeDisStatu = i18n.t('basicinfo.DisCharged')
        })

        // 处理一个循环里有多个充电时，最后两个充电的num正确，前面的不正确 eg:2 3 3
        for (var i = 0; i < this.chargedRecordsList.length; i++) {
          for (var j = i + 1; j < this.chargedRecordsList.length; j++) {
            if (this.chargedRecordsList[i].cycles == this.chargedRecordsList[j].cycles) {
              this.chargedRecordsList[i].num = this.chargedRecordsList[j].num
              if (this.chargedRecordsList[i].isChargeing && this.chargedRecordsList[j].isChargeing) {
                this.chargedRecordsList[i].chargingNum = this.chargedRecordsList[j].chargingNum
              }
            }
          }
        }
        for (var i = 0; i < this.chargedRecordsList.length; i++) {
          var arr = this.chargedRecordsList
          arr[i].myCycleNum = arr[i].chargingNum
        }
        // 处理一个循环里有多个充电时，只要第一个充电的myCycleNum，其他的myCycleNum=0
        for (var i = 1; i < this.chargedRecordsList.length; i++) {
          var arr = this.chargedRecordsList
          if (arr[i].cycles == arr[i - 1].cycles && arr[i].chargingNum > 1 && arr[i].chargingNum == arr[i - 1].chargingNum && arr[i].isChargeing) {
            arr[i].myCycleNum = 0
          }
        }
        // 同一个循环中，充电时间为所有充电项时间的和，结束电量为循环中最后一个充电项的电量
        this.chargedRecordsList.forEach((v, i) => {
          if (i < this.chargedRecordsList.length - 1) {
            if (v.num > 2 && v.isChargeing && i + v.num - 2 < this.chargedRecordsList.length - 1) {
              // 让这个循环中的充电第一项的结束时间/电量等于本循环中的最后一项的结束时间/电量  i + v.num - 2：本循环中的最后一项
              v.startCycleTime = v.startTimeRes || v.startTime
              v.endCycleTime = this.chargedRecordsList[i + v.num - 2].endTimeRes || this.chargedRecordsList[i + v.num - 2].endTime
              v.startCycleSoc = parseInt(v.startSoc)
              v.endCyclesSoc = Math.floor(parseInt(this.chargedRecordsList[i + v.num - 2].endSoc))
            }
          }
        })
        this.chargedRecordsList.forEach((v, i) => {
          if (i > 0) {
            if (v.num > 2 && v.isChargeing && v.myCycleNum == 0) {
              // 让这个循环中的充电项都等于充电第一项的结束时间/电量，避免出现：满充、临时充电、满充、临时充电
              v.startCycleTime = this.chargedRecordsList[i - 1].startCycleTime
              v.endCycleTime = this.chargedRecordsList[i - 1].endCycleTime
              v.startCycleSoc = this.chargedRecordsList[i - 1].startCycleSoc
              v.endCyclesSoc = this.chargedRecordsList[i - 1].endCyclesSoc
            }
          }
        })
        this.getFullChargeStatu()// 判断充放电记录表格中的满充和临时充电
        // console.log('this.chargedRecordsList----', JSON.stringify(this.chargedRecordsList))
        // 放电柱状图
        myChart2.hideLoading()
        const data = response.resultModel
        if (!data || (data && data.length < 1)) { this.columnLineNoData = true } else { this.columnLineNoData = false }
        console.log('data-------------', data)
        for (const i in data) {
          var model = data[i]

          n.push(getDateAndHour(model.endTime, 'noYear'))
          socData.push(this.doubleToInt(model.endSoc))

          if (this.minSoc > model.endSoc) {
            this.minSoc = this.doubleToInt(model.endSoc)
          }
          // debugger
          if (model.isChargeing) {
            // this.dataSize++
            // var difference = parseFloat(model.endAh - model.startAh)
            // this.chargedAh = this.chargedAh + difference
            chargeData.push({
              value: parseFloat(model.endAh - model.startAh).toFixed(2), symbolSize: 1, tooltip: {
                formatter: this.myFormat(model)
              }
            })

            disChargeData.push('')
          } else {
            disChargeData.push({
              value: parseFloat(model.endAh - model.startAh).toFixed(2), symbolSize: 1, tooltip: {
                formatter: this.myFormat(model)
              }
            })
            chargeData.push('')
          }
        }

        var option2 = {
          tooltip: {
            trigger: 'axis',
            show: true,
            showDelay: 50,
            hideDelay: 50,
            transitionDuration: 0,
            backgroundColor: 'rgba(0,0,0,0.7)',
            borderColor: '#f50',
            borderRadius: 10,
            borderWidth: 0,
            padding: 10,
            textStyle: {
              color: '#F9F7F7',
              decoration: 'none',
              fontFamily: 'Verdana, sans-serif',
              fontSize: 10,
              fontStyle: 'italic'
            }
            // formatter: function(params, ticket, callback) {
            //   var res = params[0].name
            //   for (var i = 0, l = params.length; i < l; i++) {
            //     res += '<br/>' + params[i].seriesName + ': ' + params[i].value
            //   }
            //   setTimeout(function() {
            //     callback(ticket, res)
            //   }, 10)
            //   return 'loading'
            // }
          },
          legend: {
            data: [i18n.t('basicinfo.Charged'), i18n.t('basicinfo.DisCharged'), i18n.t('warningPage.SOC')],
            itemGap: 60
          },
          dataZoom: [{
            type: 'slider',
            show: true,
            start: 10,
            end: 90,
            handleSize: 8
          },
          {
            type: 'inside',
            start: 10,
            end: 90
          }

          ],
          calculable: true,
          xAxis: [
            {
              type: 'category',
              data: n,
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              splitLine: {
                show: false,
                color: '#272456'
              },

              axisLabel: {
                formatter: '{value} Ah',
                color: '#59588D'
              }
            },
            {
              type: 'value',
              name: 'SOC',
              splitLine: {
                show: false
              },
              axisLabel: {
                formatter: '{value} %'
              }
            }
          ],
          color: ['#7fb80e', '#009ad6', '#A9F5F2'],
          series: [

            {
              name: i18n.t('basicinfo.Charged'),
              type: 'bar',
              barWidth: 20,
              data: chargeData,
              interval: 20,
              tooltip: {
                trigger: 'item'
              },
              label: {
                normal: {
                  show: true,
                  position: ['-5', '-20'],
                  distance: 1,
                  formatter: [
                    '{a|{c}}'
                  ].join(''),
                  rich: {

                    a: {
                      color: '#7fb80e',
                      align: 'center'
                    }

                  }
                }
              }
            },
            {
              barGap: '-100%',
              name: i18n.t('basicinfo.DisCharged'),
              type: 'bar',
              barWidth: 20,
              interval: 20,
              data: disChargeData,
              tooltip: {
                trigger: 'item'

              },
              label: {
                normal: {
                  show: true,
                  position: ['-5', '-20'],
                  distance: 1,
                  formatter: [
                    '{a|{c}}'
                  ].join(''),
                  rich: {

                    a: {
                      color: '#009ad6',
                      align: 'center'
                    }

                  }
                }
              }
            },
            {
              name: i18n.t('warningPage.SOC'),
              type: 'line',
              yAxisIndex: 1,
              data: socData,
              itemStyle: {
                normal: {
                  label: {
                    formatter: [
                      '{a|{c}}'
                    ].join(''),
                    rich: {

                      a: {
                        color: '#0B3B39',
                        align: 'center',
                        testsize: 18
                      }

                    },
                    show: true,
                    position: 'left'
                  }
                }
              }
            }
          ]
        }
        // this.columnLineData.chargeData = chargeData
        // this.columnLineData.disChargeData = disChargeData
        // this.columnLineData.socData = socData
        // this.columnLineN = n
        // console.log(option2)
        if (option2 && typeof option2 === 'object') {
          myChart2.setOption(option2, true)
          // console.log('this.myPieChart=====================', myChart2)
          // myChart2.on('finished', function() { // 图表渲染完成后
          //   this.jlcgImgBase64 = myChart2.getDataURL()
          //   document.getElementById('chart2').style.display = 'none'
          //   document.getElementById('chart3').style.display = 'block'
          //   document.getElementById('chart3').setAttribute('src', this.jlcgImgBase64)
          // })
        }
      })
    },
    getFullChargeStatu () { // 判断充放电记录表格中的满充和临时充电
      var fullChargeTime = this.basicinfo.fullChargeTime || 30
      if (this.chargedRecordsList.length > 0) {
        this.chargedRecordsList.forEach(v => {
          if (v.startCycleTime && v.endCycleTime) {
            v.myTime = (v.startCycleTime - v.endCycleTime) / (1000 * 60)
          } else if (v.startTimeRes && v.endTimeRes) {
            v.myTime = (v.endTimeRes - v.startTimeRes) / (1000 * 60)
          } else if (!v.startTimeRes && v.startTime && v.endTime) {
            v.myTime = (v.endTime - v.startTime) / (1000 * 60)
          } else {
            v.myTime = 0
          }
          if (!v.isChargeing) { // 放电
            v.chargingTypeZh = '--'
          } else if ((v.endCyclesSoc && v.endCyclesSoc == 100) || (v.endSoc == '100%' || (typeof (v.endSoc) === 'number' && Math.floor(v.endSoc) == 100)) && v.isChargeing && v.myTime >= fullChargeTime) {
            v.chargingTypeZh = i18n.t('yhubReport.FullCharge') // '满充'
          } else {
            v.chargingTypeZh = i18n.t('yhubReport.Intermediate')// '临时充电'
          }
        })
      }
    },
    getOptionsLocal () {
      return [{
        value: '1',
        label: this.$t('detail.yesterday')
      }, {
        value: '2',
        label: this.$t('detail.lastWeek')
      }, {
        value: '3',
        label: this.$t('detail.lastMonth')
      }]
    },
    doubleToInt: function (d) {
      if (d !== null) {
        return Math.round(d)
      } else {
        return 0
      }
    },
    myFormat (params) {
      var str = ''
      const ah = thousandFn(parseFloat(params.endAh - params.startAh).toFixed(2)) || 0
      if (params.isChargeing) {
        str = '<h2>' + i18n.t('yhubReport.ChargedInfo') + '</h2>' +
          i18n.t('yhubReport.TotalAh') + ':\t' + ah + '\tAh' +
          '<br/>' + i18n.t('yhubReport.StartingTime') + ':\t' + getDateAndHour(params.startTime, 'noYear') + '\t\t' + parseFloat(params.startSoc).toFixed(0) + '\t %' +
          '<br/>' + i18n.t('yhubReport.EndTime') + ':\t' + getDateAndHour(params.endTime, 'noYear') + '\t\t' + parseFloat(params.endSoc).toFixed(0) + '\t %' +
          '<br/>' + i18n.t('yhubReport.MinTemp') + ':\t' + temChange(parseFloat(params.minTemp / 100).toFixed(0)) + '\t' + temUnit() +
          '<br/>' + i18n.t('yhubReport.MaxTemp') + ':\t' + temChange(parseFloat(params.maxTemp / 100).toFixed(0)) + '\t' + temUnit() +
          '<br/>' + i18n.t('yhubReport.MinVoltage') + ':\t' + params.minVoltage / 100 + '\tV' +
          '<br/>' + i18n.t('yhubReport.MaxVoltage') + ':\t' + params.maxVoltage / 100 + '\tV'
      } else {
        str = '<h2>' + i18n.t('yhubReport.DischargedInfo') + '</h2>' +
          i18n.t('yhubReport.TotalAh') + ':\t' + ah + '\tAh' +
          '<br/>' + i18n.t('yhubReport.DepthDischarge') + ':\t' + parseFloat(100 - params.endSoc).toFixed(0) + '\t%' +
          '<br/>' + i18n.t('yhubReport.EndTime') + ':\t' + getDateAndHour(params.endTime, 'noYear') + '\t\t' + parseFloat(params.endSoc).toFixed(0) + '\t%' +
          '<br/>' + i18n.t('yhubReport.MinTemp') + ':\t' + temChange(parseFloat(params.minTemp / 100).toFixed(0)) + '\t' + temUnit() +
          '<br/>' + i18n.t('yhubReport.MaxTemp') + ':\t' + temChange(parseFloat(params.maxTemp / 100).toFixed(0)) + '\t' + temUnit() +
          '<br/>' + i18n.t('yhubReport.MinVoltage') + ':\t' + params.minVoltage / 100 + '\tV' +
          '<br/>' + i18n.t('yhubReport.MaxVoltage') + ':\t' + params.maxVoltage / 100 + '\tV'
      }
      return str
    },
    // 折线图----end
    rowIndex ({ row, rowIndex }) {
      row.rowIndex = rowIndex
    },
    formatter (row) {
      return row.rowIndex + 1
    },
    // 下载周报--pdf
    downWeekReport () {
      this.isPrint = true
      // this.isShowLogo = true
      // document.getElementById('chart2').style.display = 'none'
      // document.getElementById('chart3').style.display = 'block'
      setTimeout(() => {
        var headHtml = "<head><style type='text/css' media='print'> @page{ size:  auto;   /* auto is the initial value */margin: 0mm;  /* this affects the margin in the printer settings */}html{/*background-color: #FFFFFF; */margin: 0px;  /* this affects the margin on the html before sending to printer */}</style></head><body>"
        var bottHtml = '<p style="height:30px;position:relative;float:right;right:20px;border-top:1px solid block;">' + 'Print Time：' + getDateAndHour(new Date().getTime(), 'noTime') + '</p></body>'
        var bdhtml = document.getElementById('mainContent').innerHTML // 获取当前页的html代码
        var prnhtml = headHtml + bdhtml + bottHtml // 从结束代码向前取html

        // var styleHtml =  " style = '' ";
        window.document.body.innerHTML = prnhtml
        window.print()
        window.document.body.innerHTML = bdhtml
        this.$router.go(0)
        this.isPrint = false
      }, 0)
    },
    queryLine () { // 弹窗--折线图

      var params = {
        // sn: this.popSn,
        startDate: new Date(this.popStartDate).getTime(),
        endDate: new Date(this.popEndDate).getTime(),
        mcuId: this.$route.query.mcuId,
        showAll: this.showAll
      }
      listRecordData(params).then(res => { // 弹窗折线图数据
        console.log('图表数据：', res)
        this.loading = false
        var gnssProto
        const buf = protobuf.util.newBuffer(res)
        gnssProto = GNSSProto.decode(buf)
        const dataList = gnssProto.recordDatas ? gnssProto.recordDatas.recordData : []
        this.nodata = !(dataList.length > 0)
        for (const i in this.lineChartData) {
          this.lineChartData[i] = []
        }
        console.log('dataList----', dataList)
        // ['Cha.(A)', 'Dis.(A)', 'Volt(V)', 'Cha.(Ah)', 'Dis.(Ah)', 'SOC(%)', 'Temp.(℃)']
        var lastTime = null
        var dataSize = dataList.length
        for (const i in dataList) {
          var data = dataList[i]
          var time = dataList[i].time
          if (dataSize > 50000) {
            if (lastTime == null) {
              lastTime = time
            }
            if ((time - lastTime) / 1000 <= 10) {
              continue
            }
            lastTime = time
          }
          var ignition = data.ignitionVol / 100 > this.basicinfo.openIgnitionVol ? 1 : 0
          var hourMeter = data.hourMeterVol / 100 > this.basicinfo.workHourmeterVol ? 1 : 0
          this.lineChartData.sn = this.basicinfo.deviceSn
          this.lineChartData.d3.push([time, (data.ChargingCurrent / 100).toFixed(2)])
          this.lineChartData.d4.push([time, (data.DisChargingCurrent / 100).toFixed(2)])
          this.lineChartData.d5.push([time, (data.voltage / 100).toFixed(2)])
          this.lineChartData.d6.push([time, (data.TotalChargedAh / 100).toFixed(2)])
          this.lineChartData.d7.push([time, (data.TotalDisChargedAh / 100).toFixed(2)])
          this.lineChartData.d8.push([time, (data.soc / 100).toFixed(0)])
          this.lineChartData.d9.push([time, temChange(Math.floor(data.BatteryTemperature / 100))])
          this.lineChartData.d10.push([time, (data.chargingWh / 100000).toFixed(2)])
          this.lineChartData.d11.push([time, (data.usingWh / 100000).toFixed(2)])
          this.lineChartData.a1.push([time, ignition])
          this.lineChartData.a2.push([time, hourMeter])
          this.lineChartData.a3.push([time, (data.auxBatVol / 100).toFixed(2)])
          this.lineChartData.a32.push([time, (data.voltage / 100 - data.auxBatVol / 100).toFixed(2)])
          if (data.auxCurrent > 0) { // 放电
            this.lineChartData.a4.push([time, (data.auxCurrent / 10).toFixed(2)])
            this.lineChartData.a5.push([time, 0])
          } else if (data.auxCurrent < 0) { // 充电
            this.lineChartData.a4.push([time, 0])
            this.lineChartData.a5.push([time, -(data.auxCurrent / 10).toFixed(2)])
          } else {
            this.lineChartData.a4.push([time, 0])
            this.lineChartData.a5.push([time, 0])
          }
          this.lineChartData.a6.push([time, (data.auxSoc / 100).toFixed(0)])
          this.lineChartData.a7.push([time, (data.socVolt / 100).toFixed(0)])
        }
      })
    },
    readMore (item) { // 弹窗--显示
      this.loading = true
      if (item != null) {
        this.popStartDate = item.startTimeRes
        this.popEndDate = item.endTimeRes
      } else {
        this.popStartDate = this.weekReportStartTime
        this.popEndDate = this.weekReportEndTime
      }
      // if (this.lineChartData.d3.length == 0 && this.lineChartData.d4.length == 0 && this.lineChartData.d5.length == 0 && this.lineChartData.d6.length == 0 &&
      //   this.lineChartData.d7.length == 0 && this.lineChartData.d8.length == 0 && this.lineChartData.d9.length == 0) {
      this.queryLine()
      // }
      this.isShowPop = true
      // 当在监控点击切换的时候，加个延迟主动触发窗口变化，这样窗口改变性能分析页就不会发生图表大小有问题的情况了 【这里的代码是关键！！！】
      setTimeout(() => {
        const triggerResize = new Event('resize')
        window.dispatchEvent(triggerResize)
      }, 0)
    },
    closePop () { // 弹窗--关闭
      this.isShowPop = false
    },
    changeSearch () { // 弹窗--时间选择
      this.loading = true
      this.queryLine()
    },
    change () {
      this.$forceUpdate()
    },
    submitPop () { // Download Raw CSV--下载
      this.isShowRegionPop = false
      this.isShowLoadingPop = true
      setTimeout(() => {
        this.isShowLoadingPop = false
      }, 5000)
      var param = {
        sn: this.basicinfo.deviceSn,
        mcuId: this.$route.query.mcuId,
        startDate: new Date(this.popStartDate).getTime(),
        endDate: new Date(this.popEndDate).getTime()
      }
      var timeZ = new Date().getTimezoneOffset() / 60

      var paramTimeZ = 'GMT'
      if (timeZ < 0) {
        paramTimeZ = paramTimeZ + '%2B' + (timeZ * -1)
      } else {
        paramTimeZ = paramTimeZ + (timeZ * -1)
      }
      // console.log(param)
      // var url = 'http://10.0.0.22:8008/v3/report/exportRecordDataCsv'
      var url = process.env.VUE_APP_BASE_API + '/v3/report/exportRecordDataCsv'
      url += '?endDate=' + param.endDate + '&mcuId=' + param.mcuId + '&startDate=' + param.startDate + '&sn=' + param.sn + '&columns=' + this.legendselectStr + '&timeZone=' + paramTimeZ + '&regionType=' + this.regionType + '&showAll=' + this.showAll
      window.open(url, '_bank')
    },
    downLoadExcel () { // Download Raw CSV--打开选中数字分割选项的弹窗
      this.isShowRegionPop = true
    },
    downLoadReportExcel () { // Download Report CSV
      this.isShowLoadingPop = true
      setTimeout(() => {
        this.isShowLoadingPop = false
      }, 5000)
      var param = {
        sn: this.basicinfo.deviceSn,
        mcuId: this.$route.query.mcuId,
        startDate: parseInt(new Date(this.popStartDate).getTime()),
        endDate: parseInt(new Date(this.popEndDate).getTime())
      }
      var timeZ = new Date().getTimezoneOffset() / 60
      var paramTimeZ = 'GMT'
      if (timeZ < 0) {
        paramTimeZ = paramTimeZ + '%2B' + (timeZ * -1)
      } else {
        paramTimeZ = paramTimeZ + (timeZ * -1)
      }
      var tem = this.$store.state.temType == 'hsd' ? 'F' : 'C'
      // var url = 'http://10.0.0.22:8008/v3/report/exportRecordDataCsv'
      var url = process.env.VUE_APP_BASE_API + '/v3/report/getcsv?sn='
      // url += '?endDate=' + param.endDate + '&mcuId=' + param.mcuId + '&startDate=' + param.startDate + '&sn=' + this.listQuery.sn
      url += param.sn + '&startTime=' + param.startDate + '&endTime=' + param.endDate + '&timeZone=' + paramTimeZ + '&showAll=' + this.showAll + '&tem=' + tem
      window.open(url, '_bank')
    },
    legendselect (str) {
      this.legendselectStr = str
    },
    downChargeDis () { // 下载充放电数据
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          i18n.t('yhubReport.index'),
          i18n.t('yhubReport.StartingTime'),
          i18n.t('yhubReport.StartSOC'),
          i18n.t('yhubReport.EndTime'),
          i18n.t('yhubReport.EndSOC'),
          i18n.t('yhubReport.ah'),
          'KWH',
          i18n.t('yhubReport.StartTemp'),
          i18n.t('yhubReport.EndTemp'),
          i18n.t('yhubReport.averageTemp'),
          i18n.t('yhubReport.MinVoltage'),
          i18n.t('yhubReport.MaxVoltage'),
          i18n.t('yhubReport.ChargType'),
          i18n.t('yhubReport.Duration'),
          i18n.t('AllDevices.Status')
        ]
        const filterVal = [
          'cycles',
          'startTime',
          'startSoc',
          'endTime',
          'endSoc',
          'energy',
          'wh',
          'startTemp',
          'endTemp',
          'avgTemp',
          'minVoltage',
          'maxVoltage',
          'chargingTypeZh',
          'chargedTime',
          'chargeDisStatu'
        ]
        const list = this.chargedRecordsList
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'chargedRecords',
          autoWidth: true,
          bookType: 'xlsx'
        })
      })
    },
    downDeviceSummary () { // 下载每日统计数据
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          i18n.t('yhubReport.Date'),
          i18n.t('yhubReport.WorkingHours'),
          i18n.t('yhubReport.UseTime'),
          i18n.t('yhubReport.Discharge'),
          i18n.t('basicinfo.DisCharged'),
          i18n.t('yhubReport.ChargingTime'),
          i18n.t('yhubReport.Charge'),
          i18n.t('basicinfo.Charged'),
          i18n.t('yhubReport.MinimumSOC'),
          i18n.t('yhubReport.MinimumVoltage'),
          i18n.t('yhubReport.MaximumTemperature')
        ]
        const filterVal = [
          'monthDay',
          'workTimeZh',
          'usedTimeZh',
          'usedAhZh',
          'usingWhZh',
          'chargeTimeZh',
          'charedAhZh',
          'chargingWhZh',
          'minSocZh',
          'minVoltageZh',
          'maxTempratureZh'
        ]
        const list = this.devicesSummaryList
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'deviceSummary',
          autoWidth: true,
          bookType: 'xlsx'
        })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        })
      )
    },
    openCountSohPop (item) { // 弹窗--手动计算soh--显示
      console.log('item', item)
      this.isShowCountSOHPop = true
      this.sohSearchObj.sohStartTime = item.startTimeRes
      this.sohSearchObj.sohEndTime = item.endTimeRes
      var star = new Date(this.sohSearchObj.sohStartTime).getTime()
      var end = new Date(this.sohSearchObj.sohEndTime).getTime()
      this.querySoh(star, end)
      // this.computedSoh()
    },
    computedSoh () { // 手动计算soh
      var param = {
        'startDate': new Date(this.sohSearchObj.sohStartTime).getTime(),
        'endDate': new Date(this.sohSearchObj.sohEndTime).getTime(),
        'mcuId': this.$route.query.mcuId,
        'ignoreCharge': this.sohSearchObj.ignoreCharge,
        'updateData': this.sohSearchObj.updateData
      }
      this.loadingSoh = true
      // 因为一条充放电记录数据起止时间可能大于3天，所以暂时去掉3天限制
      // if (param.endDate - param.startDate > 24 * 60 * 60 * 1000 * 3) {
      //   this.$message({
      //     type: 'warning',
      //     message: '起止时间不能太大，必须控制在3天内'// i18n.t('allDeviceDetail.DeviceNameCannotEmpty')
      //   })
      //   return
      // }
      countSoh(param).then(res => {
        this.loadingSoh = false
        if (res.resultCode == 1001) {
          if (!res.resultModel) {
            this.$message({
              type: 'success',
              message: i18n.t('allDeviceDetail.noEligibleData')// '计算成功,但本次计算无符合条件的数据！'
            })
          }
          if (res.resultModel) {
            this.$message({
              type: 'success',
              message: i18n.t('allDeviceDetail.calcSuccess')// '计算成功！'
            })
            var star = new Date(this.sohSearchObj.sohStartTime).getTime()
            var end = new Date(this.sohSearchObj.sohEndTime).getTime()
            this.querySoh(star, end)
          }
        }
      })
    },
    toCalculateChargeDischarge () {
      var param = {
        'startDate': new Date(this.selectDayWeekReport[0]).getTime(),
        'endDate': new Date(this.selectDayWeekReport[1]).getTime() + 24 * 60 * 60 * 1000 - 1000,
        'mcuId': this.$route.query.mcuId
      }
      if (param.endDate - param.startDate > 60 * 24 * 60 * 60 * 1000 - 1000) {
        this.$message({
          type: 'error',
          message: i18n.t('yhubReport.calculateChargeDischargeExceeded') // 每次最多计算60天内的充放电报表
        })
        return
      }
      this.$confirm(i18n.t('yhubReport.confirmCalculateChargeDischarge'), '', {
        // 是否确定重新计算充放电？
        confirmButtonText: i18n.t('button.Confirm'), // '确定'
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        calculateChargeDischarge(param).then((res) => {
          if (res.resultCode == '1001') {
            this.$message({
              type: 'success',
              message: i18n.t('warningSet.submitted') // 重算充放电成功
            })
            this.initChart2()
          }
        })
      }).catch(() => { })
    },
    querySoh (star, end) {
      var param = {
        startTime: '',
        endTime: '',
        mcuId: this.$route.query.mcuId
      }
      if (star) {
        param.startTime = star
        param.endTime = end
      }
      listSohRecord(param).then(res => {
        if (res.resultCode != 1001 || !res.resultModel) return
        this.sohData = res.resultModel
        this.sohData.forEach(v => {
          for (var attr in v) {
            if (attr == 'current_capacity' || attr == 'socVolt' || attr == 'soc_ll' || attr == 'soc_ph' || attr == 'soc_wph' || attr == 'soc_zt' || attr == 'soh_avg' || attr == 'theoretical_capacity') {
              v[attr] = Math.round(v[attr])
            }
            v.start_timeZh = getDateAndHour(v.start_time)
            v.end_timeZh = getDateAndHour(v.end_time)
          }
        })
      })
    },
    // 分页----start
    handleSizeChange (val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryWarnings()
    },
    handleCurrentChange (val, e) {
      // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryWarnings()
    }

  }
}
function timestampformat (timestamp) {
  // return (new Date(timestamp)).Format('dd/MM hh:mm')
  return getDateAndHour(new Date(timestamp), 'noYear')
}
</script>

<style lang="scss" scoped>
// @import './resettable.css';
@media print {
  html,
  body {
    //A4默认为210mm*287mm
    width: 210mm;
    height: 297mm;
  }
  .page {
    font-size: 10pt;
    width: initial;
  }
  .page .part2 td {
    height: 1cm;
  }
  // .myTable{
  //   width:200mm;
  // }
}
.section_box {
  background-color: #fff;
  padding: 20px;
  margin: 20px 0;
}
.regionP {
  margin: 10px;
  font-weight: bold;
  display: inline-block;
}
.regionPop .el-radio {
  margin-left: 10px;
}
// .columnTable tr:nth-of-type(even){
.oddTr {
  background: #f0f2f5a3;
}
.questionPop,
.dischargePop,
.WorkTimeWarp,
.usedTimeWarp {
  display: inline-block;
  background: white;
  padding: 14px;
  vertical-align: top;
  box-shadow: 1px 1px 5px #ccc;
  position: absolute;
  z-index: 999;
  // margin: -120px 0 0 160px;
  left: 120px;
  bottom: 40px;
  max-width: 100%;
}
.questionPop {
  width: 100%;
}
.dischargePop {
  margin: 0;
  width: auto;
  bottom: auto;
  left: 50%;
  top: 25px;
  transform: translate(-50%, 0);
}
.WorkTimeWarp,
.usedTimeWarp {
  margin: 0;
  left: 10%;
  width: auto;
  bottom: auto;
  top: -50px;
}
.usedTimeWarp {
  left: 15%;
}
.yhubHeader {
  background: white;
  height: 108px;
  margin: 0 !important;
  // margin-right:0!important;
}
.yhubHeaderP {
  display: inline-block;
  width: 100%;
  line-height: 108px;
  font-size: 20px;
  font-weight: bold;
  position: relative;
  padding-left: 20px;
}
.yhubHeaderP span {
  font-size: 16px;
  line-height: 16px;
  font-weight: normal;
  position: absolute;
  right: 20px;
  bottom: 20px;
}
.blockTitleP {
  font-size: 16px;
  color: #000;
  line-height: 16px;
  font-weight: bold;
  padding: 20px 0;
}
.warningP {
  background: #ffffcc;
  line-height: 40px;
  border: 1px solid #ffcc99;
  border-radius: 5px;
  padding-left: 10px;
  margin: 5px 0;
}
.changePieBtn {
  outline: none; //消除默认点击蓝色边框效果
  height: 25px;
  padding: 0 10px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #c2e7b0;
  background: #f0f9eb;
  margin-bottom: 10px;
  position: relative;
}
.changePieBtn:nth-of-type(1) {
  // margin-right:10px;
  margin-left: calc(1% + 5px);
}
.active {
  border: 1px solid #67c23a;
  background: #67c23a;
  color: white;
}
.downBtn {
  height: 35px;
  line-height: 35px;
  background: #a9d252;
  display: inline-block;
  border-radius: 10px;
  padding: 0 10px;
  color: white;
  position: absolute;
  right: 30px;
  top: 20px;
  cursor: pointer;
}
.popWrap {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 2;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.popContent {
  background: white;
  width: 80%;
  height: 80%;
  padding: 20px;
}
#mainContent .el-dialog {
  margin-top: 10vh !important;
}
</style>
